import { gql } from '@apollo/client';

export const SAVE_ADDITIONAL_PHOTOS_RECOMMENDATION = gql`
  mutation SaveAdditionalPhotosRecommendation($input: SaveRecommendationInput!) {
    saveAdditionalPhotosRecommendation(input: $input) {
      id
    }
  }
`;
